<div class="preview_container" *ngIf="detailsComparator$ | async as detailsComparator">
    <div class="table_products">
        <div style="display: flex; justify-content: space-between;"  class="header_preview">
            <h2>{{ detailsComparator.preview.products.length}} {{"Catalogs.products_included"|translate}}</h2>
            <div style="display: flex;"> 
                <div style="display: flex; flex-direction: column; align-items: center; padding: 10px;color: #000; cursor: pointer;" class="add_btn"  (click)="exportComparators()">
                    <img src="assets/icones/export_icon.svg" alt="">
                    <span>{{"common.export"|translate}}</span>
                </div>
                <div class="filter_btns">
                    <button class="filter" (click)="setFilter('comparatorFilter')">
                    <img src="assets/icones/search-filter.svg" alt="" />
                    <span>{{ "common.filter" | translate | titlecase }}</span>
                    </button>
                    <button
                    class="clear"
                    (click)="clearFilter()"
                      *ngIf="isFilter"
                    >
                    <small>{{ "common.clear" | translate | titlecase }}</small>
                    <img src="assets/icones/clear-filter.svg" alt="" />
                    </button>
                </div>
            </div>
        </div>
        <div class="page_container preview_container_products">
            <table class="listing_table preview">
                <thead class="header_stiky">
                    <tr class="head_preview">
                        <th>{{"common.image"| translate}}</th>
                        <th>{{"common.name"| translate}} <br> {{"inventory.sku"|translate}}</th>
                        <th class="number_clmn">{{"comparator.imported_price"| translate}}</th>
                        <th class="number_clmn">{{"comparator.inventory_price"|translate}} <br> {{"comparator.different"|translate}}</th>
                        <th>{{"comparator.other_prices"| translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let product of filtredProducts">
                        <tr class="body_preview hover_tr">
                            <td class="first_td">
                                <img class="listing_image" *ngIf="product['product_id'] && product['image']" [src]="baseUrl + product['image']" alt="">
                                <img class="listing_image" *ngIf="!product['product_id'] || !product['image']" src="assets/icones/no-image.png" alt="">
                            </td>
                            <td class="td_block cursor number_clmn_offer">
                                <span class="bold_span">{{ product['name'] }}</span>
                                <span *ngIf="!product['name']" class="descr_elemnt bold_span no_product">{{ "comparator.product_not_exist" | translate }}</span>
                                <span class="light_span">{{ product['sku'] }}</span>
                            </td>
                            <td class="number_clmn">
                                {{ product['price'] }} €
                            </td>
                            <td class="number_clmn">
                                <div class="number_clmn_offer" *ngIf="product['actual_price']">
                                    <span>{{ product['actual_price']}} €</span>
                                    <span class="offer_span" [class.danger]="product['price'] > product['actual_price']"> {{ (product['price'] - product['actual_price']).toFixed(2) }} € </span>
                                </div>
                            </td>
                            <td>
                                <div class="td_offers">
                                    <div class="other_prices" *ngIf="product['other_imported_prices'] && product['other_imported_prices'].length > 0">
                                        <button class="btn_show_more" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
                                            + {{product['other_imported_prices'].length}} 
                                            <mat-icon *ngIf="!menuTrigger.menuOpen">keyboard_arrow_down</mat-icon>
                                            <mat-icon *ngIf="menuTrigger.menuOpen">keyboard_arrow_up</mat-icon>
                                            <span *ngIf="!menuTrigger.menuOpen">{{"inventory.SHOW"|translate}}</span>
                                            <span *ngIf="menuTrigger.menuOpen">{{"inventory.HIDE"|translate}}</span>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <div class="mat_menu_item">
                                                <div class="header">
                                                    <div class="menu_title">{{product['other_imported_prices'].length}} {{"comparator.other_prices"| translate}}</div>
                                                </div>
                                                <div class="item_menu" *ngFor="let item of product['other_imported_prices']">
                                                    <div>{{item.supplier}}</div>
                                                    <div class="file_div">
                                                        <div class="file_name" (click)="downloadFile(item)">
                                                            <img src="../../../../../assets/icones/icons_xls.svg" alt="">
                                                            <span class="file_name_span">{{item.file_name}}</span>
                                                            <img src="../../../../../assets/icones/icon_download.svg" alt="">
                                                        </div>
                                                        <div class="lowest_price" *ngIf="isLowestPrice(product['other_imported_prices'], item)">
                                                            {{"comparator.lowest_price"| translate}}
                                                        </div>
                                                    </div>
                                                    <div class="expiration_date">{{item.expiration_date }} ({{item.expiration_date | daysAgoOrLeft}})</div>
                                                </div>
                                            </div>
                                        </mat-menu>
                                    </div>
                                    <div *ngIf="product['other_imported_prices'] && product['other_imported_prices'].length > 0">
                                        <span class="offer_span">{{getBetterOffers(product['other_imported_prices'], product['price'])}} {{"comparator.better_offer"|translate}}</span>
                                    </div>
                                </div>
                                <div>
                                    <span *ngIf="!product['other_imported_prices'] || product['other_imported_prices'].length == 0">
                                        {{"comparator.no_previous_data"| translate}}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="footer_statistic">
            <div></div>
            <div class="statistic">
                {{"common.total_products"| translate}} <br> <strong>{{detailsComparator.preview.products.length}}</strong>
            </div>
            <div></div>
            <div class="statistic custom_statistic">
                <span>
                    {{"comparator.better_offers" | translate}} <br> <strong>{{getTotalBetterOffers(detailsComparator)}}</strong>
                </span>
            </div>
            <div class="statistic">{{"comparator.better_offers" | translate}} <br> <strong>{{getTotalOthersBetterOffers(detailsComparator)}}</strong></div>
        </div>
    </div>
    <div class="foter_buttons btns_commit">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
            <span> {{"common.back"|translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_back.svg">
        </button>
        <button class="save_btn_pop_up green_btn" *ngIf="!detailsComparator.committed" (click)="commit(detailsComparator)">
            <span> {{"common.commit"|translate}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
    </div>
</div>